import { ThunkUserDispatch } from 'store/user/actions';
import { AppDispatch, RootState } from 'store';
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux';
import { ThunkVMDispatch } from 'store/virtual-machine/actions';
import { ThunkLBDispatch } from 'store/loadbalancer/action';
import { ThunkApiErrorDispatch } from 'store/api-error/actions';
import { ThunkAppNotificationDispatch } from 'store/app-notifications/actions';
import { ThunkStorageDispatch } from 'store/storage/actions';
import { ThunkProjectsDispatch } from 'store/project/action';
import { ThunkClusterDispatch } from 'store/cluster/action';
import { ThunkAsgDispatch } from 'store/autoscaling-group/action';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useUserThunkDispatch = () => useDispatch<ThunkUserDispatch>();
export const useVMThunkDispatch = () => useDispatch<ThunkVMDispatch>();
export const useLBThunkDispatch = () => useDispatch<ThunkLBDispatch>();
export const useApiErrorsThunkDispatch = () => useDispatch<ThunkApiErrorDispatch>();
export const useAppNotificationDispatch = () => useDispatch<ThunkAppNotificationDispatch>();
export const useStorageDispatch = () => useDispatch<ThunkStorageDispatch>();
export const useProjectsDispatch = () => useDispatch<ThunkProjectsDispatch>();
export const useClusterThunkDispatch = () => useDispatch<ThunkClusterDispatch>();
export const useAsgThunkDispatch = () => useDispatch<ThunkAsgDispatch>();

export { default as useNotification } from './notification';
export { default as useTableParams } from './table-params';
